import { ValidationSchema } from '../../../../../@types/validation-types'
import {
  defaultApiSearchData,
  defaultConstruction,
  defaultDescription,
  useManualAndInternationalAddress,
  usePurchasePriceOnRequestCondition,
} from '../../../../../services/validation/flow/defaultSchemas'
import { validationRules } from '../../../../../services/validation/rules/validationRules'

export const agentApartmentSellSchema: ValidationSchema = {
  address: useManualAndInternationalAddress,
  basicInfo: {
    livingSpace: validationRules.livingSpace,
    room: validationRules.room,
    price: usePurchasePriceOnRequestCondition,
    courtage: validationRules.courtage,
    courtageNote: validationRules.courtageNote,
  },
  otherFacilities: {
    noBathrooms: validationRules.noBathrooms,
    noBedrooms: validationRules.noBedrooms,
    rentSubsidy: validationRules.rentSubsidy,
    floor: validationRules.floor,
    totalFloorsNumber: validationRules.totalFloorsWithDependingFloorNumber,
    usableArea: validationRules.usableArea,
    rentalIncome: validationRules.rentalIncome,
    parkingSpaceRent: validationRules.parkingSpaceRent,
    noParkingSpaces: validationRules.noParkingSpaces,
  },
  description: { ...defaultDescription, adFurnishingNote: validationRules.adFurnishingNote },
  construction: defaultConstruction,
  objectNumbers: {
    groupNumber: validationRules.groupNumber,
  },
  apiSearchData: defaultApiSearchData,
}
